import React, {forwardRef, useImperativeHandle} from 'react'
import {Row} from 'react-material-responsive-grid'
import {AppEnv} from '../../env'
import {alertWarning, getLogo, pulseLoader} from '../NewFunctions'
import PropTypes from 'prop-types'
import {useSelector} from "react-redux";

const PasswordCheck = forwardRef(({title, f, textButton = 'Cambiar'}, ref) => {
    const [password, setPassword] = React.useState()
    const [confirmPassword, setConfirmPassword] = React.useState()
    const [matchLowerCase, setMatchLowerCase] = React.useState(false)
    const [matchUpperCase, setMatchUpperCase] = React.useState(false)
    const [matchNumber, setMatchNumber] = React.useState(false)
    const [matchLength, setMatchLength] = React.useState(false)
    const [matchPassword, setMatchPassword] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const {fourthColor} = useSelector(state => state.rooot);

    useImperativeHandle(ref, () => ({
        loadButton(value) {
            setLoading(value)
        }
    }));

    const onPasswordChange = (event) => {
        event.preventDefault()
        const text = event.target.value
        validate(text)
        setPassword(text)
    }

    const onConfirmPasswordChange = (event) => {
        event.preventDefault()
        const text = event.target.value
        setMatchPassword(text === password)
        setConfirmPassword(text)
    }

    const validate = (text) => {
        const lowerCaseRegExp = new RegExp('[a-z]')
        const upperCaseRegExp = new RegExp('[A-Z]')
        const numbersRegExp = /[0-9]/g
        const textLength = 6
        setMatchLowerCase(lowerCaseRegExp.test(text))
        setMatchUpperCase(upperCaseRegExp.test(text))
        setMatchNumber(text.match(numbersRegExp))
        setMatchLength(text.length >= textLength)
    }

    const handleClick = async (event) => {
        event.preventDefault()
        f(password)
    }

    return (
        <Row className={'uk-width-1-1 centerAll'}
             style={{
                 backgroundColor: 'rgba(255, 255, 255, 0.93)',
                 margin: 20,
                 padding: 20,
                 borderRadius: 15
             }}>
            <Row style={{margin: 5, padding: 5}} className='centerAll'>
                <img alt='' className='lazyload cuadroLogin' data-src={getLogo()}/>
            </Row>
            <p style={{marginTop: 25}} className='subnegritas'>{title}</p>
            <div className='uk-form-stacked uk-width-1-1'>
                <div>
                    <label className='labelform'>
                        Nueva Contraseña
                    </label>
                    <div>
                        <input style={{borderRadius: 6}} className='uk-input uk-width-1-1'
                               onChange={onPasswordChange} id='login-form-ce-password1' type='password'
                               placeholder='***********'/>
                    </div>
                </div>
                <div style={{marginTop: 10}} className='uk-width-1-1@s centerAll'>
                    <label className='label-form'>
                        Confirmar Contraseña
                    </label>
                    <div>
                        <input style={{borderRadius: 6}} className='uk-input uk-width-1-1'
                               onChange={onConfirmPasswordChange} id='login-form-ce-password2' type='password'
                               placeholder='***********'/>
                    </div>
                </div>
            </div>
            <Row
                className="uk-width-1-1 centerAll normal_text"
                style={{
                    margin: 0,
                    padding: 10,
                    borderRadius: 6,
                    backgroundColor: AppEnv.grayColorOne,
                    marginTop: 10
                }}
            >
                <Row className="uk-width-5-6" style={{fontSize: '1rem'}}>
                    {matchLowerCase ? <div className="uk-width-1-6" style={{textAlign: 'center'}}>
                        <i className="fas fa-check" color={AppEnv.greenColor}/>
                    </div> : null}
                    {!matchLowerCase ? <div className="uk-width-1-6" style={{textAlign: 'center'}}>
                        <i className="fas fa-times" color={AppEnv.redColor}/>
                    </div> : null}
                    <div className="uk-width-5-6" style={{textAlign: 'left'}}>
                        Al menos una letra minúscula
                    </div>
                </Row>
                <Row className="uk-width-5-6" style={{fontSize: '1rem', marginTop: 5}}>
                    {matchUpperCase ? <div className="uk-width-1-6" style={{textAlign: 'center'}}>
                        <i className="fas fa-check" color={AppEnv.greenColor}/>
                    </div> : null}
                    {!matchUpperCase ? <div className="uk-width-1-6" style={{textAlign: 'center'}}>
                        <i className="fas fa-times" color={AppEnv.redColor}/>
                    </div> : null}
                    <div className="uk-width-5-6" style={{textAlign: 'left'}}>
                        Al menos una letra mayúscula
                    </div>
                </Row>
                <Row className="uk-width-5-6" style={{fontSize: '1rem', marginTop: 5}}>
                    {matchNumber ? <div className="uk-width-1-6" style={{textAlign: 'center'}}>
                        <i className="fas fa-check" color={AppEnv.greenColor}/>
                    </div> : null}
                    {!matchNumber ? <div className="uk-width-1-6" style={{textAlign: 'center'}}>
                        <i className="fas fa-times" color={AppEnv.redColor}/>
                    </div> : null}
                    <div className="uk-width-5-6" style={{textAlign: 'left'}}>
                        Al menos un número
                    </div>
                </Row>
                <Row className="uk-width-5-6" style={{fontSize: '1rem', marginTop: 5}}>
                    {matchLength ? <div className="uk-width-1-6" style={{textAlign: 'center'}}>
                        <i className="fas fa-check" color={AppEnv.greenColor}/>
                    </div> : null}
                    {!matchLength ? <div className="uk-width-1-6" style={{textAlign: 'center'}}>
                        <i className="fas fa-times" color={AppEnv.redColor}/>
                    </div> : null}
                    <div className="uk-width-5-6" style={{textAlign: 'left'}}>
                        Longitud mínima de 6 caracteres
                    </div>
                </Row>
            </Row>
            <Row style={{
                margin: 0,
                padding: 5
            }} className='uk-width-1-1@s centerAll'>
                <button style={{
                    margin: 0,
                    padding: 5,
                    marginTop: 25,
                    borderRadius: 6,
                    backgroundColor: AppEnv.secondColor,
                    textAlign: 'center',
                    fontSize: 12
                }} type='submit'
                        onClick={(event) => {
                            if (matchLowerCase && matchUpperCase && matchNumber && matchLength && password === confirmPassword) {
                                handleClick(event)
                            } else {
                                alertWarning('Asegúrate de cumplir con los requerimientos para su nueva contraseña')
                            }
                        }}
                        className='uk-button uk-button-medium uk-width-1-2 botontxt'>
                    {loading ? pulseLoader(fourthColor) : textButton}
                </button>
            </Row>
        </Row>
    )
})

PasswordCheck.propTypes = {
    title: PropTypes.string.isRequired,
    f: PropTypes.func.isRequired,
    textButton: PropTypes.string.isRequired
}

export default PasswordCheck